import close from "@icons/close.svg";
import { Hatch, SafeString } from "../classes/Hatch.js";

interface ModalOptions {
  cb?: Function;
  body: SafeString;
  onclose?: Function;
}

interface FormModalOptions extends ModalOptions {
  action: string;
  successMsg?: string;
  failedMsg?: string;
  method?: "POST" | "GET";
  cb?: Function;
}

export class Modal {
  body: SafeString;
  el: HTMLElement;
  cb?: Function;
  onclose?: Function;

  constructor(options: ModalOptions) {
    this.body = options.body;
    this.onclose = options.onclose;
    this.cb = options.cb;
    document.body.appendChild(this.getTemplate(options));
  }

  close() {
    this.el.classList.add("out");
    if (this.onclose) this.onclose();
    setTimeout(() => {
      this.el.remove();
    }, 400);
  }

  getTemplate(options: ModalOptions) {
    this.el = document.createElement("div");
    this.el.classList.add("modal");
    this.el.classList.add("out");
    this.el.innerHTML = Hatch`
            <div class="tile article">
                <button data-close>
                    <div class="ma-icon default">
                        ${new SafeString(close)}
                    </div>
                </button>
                ${options.body}
            </div>
            <div class="modal-backdrop"></div>
        `.s;

    this.el.querySelectorAll(".modal-backdrop, [data-close]").forEach((item) => {
      item.addEventListener("click", (e: Event) => {
        if (item.tagName !== "A") {
          e.preventDefault();
        }
        this.close();
      });
    });

    this.el.querySelectorAll(".modal-backdrop, [data-cb]").forEach((item) => {
      item.addEventListener("click", (e: Event) => {
        this.cb?.();
      });
    });

    window.addEventListener("keydown", (e: KeyboardEvent) => {
      if (e.key === "Escape") {
        this.close();
      }
    });

    setTimeout(() => {
      this.el.classList.remove("out");
    }, 1);
    return this.el;
  }
}

export class FormModal extends Modal {
  body: SafeString;
  action: string;
  method?: "POST" | "GET";

  constructor(options: FormModalOptions) {
    let form = Hatch`
            <form class="article" method="${options.method || "POST"}" action="${options.action}">
                ${options.body}
                <input type="hidden" name="csrf_token" value="${globalThis.csrf_token}" />
            </form>
        `;
    options.body = form;
    super(options);

    this.action = options.action;
  }
}

export class FetchFormModal extends FormModal {
  successMsg?: string;
  failedMsg?: string;
  cb?: Function;

  constructor(options: FormModalOptions) {
    super(options);
    this.successMsg = options.successMsg;
    this.failedMsg = options.failedMsg;
    this.method = options.method;
    this.cb = options.cb;
    this.afterRender();
  }

  afterRender() {
    let form = this.el.querySelector<HTMLFormElement>("form");
    form.addEventListener("submit", async (e: Event) => {
      e.preventDefault();
      let req = await fetch(this.action, {
        body: new FormData(form),
        method: this.method || "post",
      });
      if (req.ok) {
        this.close();
        if (this.cb) this.cb();
        globalThis.notification.notify({
          type: "info",
          message: this.successMsg || "The action was successful",
          title: "Success",
        });
      } else {
        globalThis.notification.notify({
          type: "danger",
          message: this.failedMsg || "The action failed, feel free to get in touch if the problem persists.",
          title: "Failed",
        });
      }
    });
  }
}
